<template>
    <div>
        <a
            v-if="completed"
            :href="downloadUrl"
        >{{ attachmentName }}</a>
        <i
            v-else
            class="icon-refresh icon-spin"
            :title="text"
        ></i>
    </div>
</template>

<script>
import ExportLogRepository from '../../js/repository/ExportLogRepository';

export default {
    props: {
        downloadUrl: {
            type: String,
            required: true,
        },
        exportLogId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            completed: false,
            interval: 1000,
            attachmentName: null,
            text: this.$t('Der Export wird im Hintergrund erstellt.'),
        };
    },
    mounted() {
        this.update();
    },
    methods: {
        update() {
            ExportLogRepository.find(this.exportLogId)
                .then((exportLog) => {
                    if (exportLog.attachmentName !== null) {
                        this.attachmentName = exportLog.attachmentName;
                        this.$notify.success('financial_accounting_export.exportIsCompleted', { file: exportLog.attachmentName });
                        this.completed = true;
                    }
                    if (!this.completed) {
                        this.scheduleUpdate();
                    }
                })
                .catch(() => this.$notify.error('Es ist ein Fehler aufgetreten. Bitte laden Sie die Seite erneut.'));
        },
        scheduleUpdate() {
            if (this.interval < 60000) {
                this.interval += this.interval;
            }
            window.setTimeout(this.update, this.interval);
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
